<template>
  <div id="contact">
      <h3>Let's Talk</h3>
      <span>For all enquiries and suggestions, please email us using the form below. 🥰</span>
      <form id="form" @submit.prevent="sendEmail">
          <div class="form-group">
            <input 
                type="text" 
                v-model="name"
                name="name"
                placeholder=" "
            required>
              <label for="name" class="label">Name</label>
          </div>
          
          <div class="form-group">
          <input 
            type="email" 
            v-model="email"
            name="email"
            placeholder=" "
            required>
              <label for="email" class="label">Email</label>
          </div>
          
          <div class="form-group">
          <input 
            type="text" 
            v-model="subject"
            name="subject"
            placeholder=" "
            required>
              <label for="subject" class="label">Subject</label>
          </div>
          
          <div class="form-group">
          <textarea 
            name="message"
            v-model="message"
            cols="30" rows="5"
            placeholder=" " required>
          </textarea>
              <label for="message" class="label">Message</label>
          </div>
          
          <button type="submit" class="get">Send Message</button>
        </form>
  </div>
</template>

<script>
import emailjs from 'emailjs-com'
export default {
    name: 'Contact',
    data() {
    return {
      name: '',
      email: '',
      subject: '',
      message: ''
    }
  },
  methods: {
    sendEmail(e) {
      try {
        emailjs.sendForm("service_mx8pt3q","template_5a45l6l", e.target,
        'user_Jd6WvPpe87isHXgyCsYGi', {
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        })
        console.log("Success, mail sent");
        alert('Message sent successfully')

      } catch(error) {
          console.log({error})
      }
      this.name = ''
      this.email = ''
      this.subject = ''
      this.message = ''
    },
  }
}
</script>

<style lang='scss' scoped>
#contact{
    background: url('../assets/Union.png');
    margin-top: -8%;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    padding: 80px 0;
    align-items: center;
    height: auto;
    font-family: 'Raleway', sans-serif;
    h3{
        font-size: 36px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 24px;
        width: 500px;
        text-align: center;
        margin-bottom: 80px;
    }
    form{
        display: flex;
        flex-direction: column;
        width: 50%;
        position: relative;
        .form-group{
            position: relative;
        }
        input, textarea{
            position: relative;
            width: 100%;
            padding: 16px 32px;
            border-radius: 4px;
            border: 1px solid #2B2D4280;
            font-size: 18px;
            margin-bottom: 36px;
            background: transparent;
            z-index: 1;
            &:hover{
                border: 1px solid #FFC727;
            }
            &:focus{
                outline: 1px solid #FFC727;
            }
        }
        .label {
            position: absolute;
            left: 1rem;
            top: 0.8em;
            padding: 0 0.5rem;
            color: #13232A80;
            cursor: text;
            -webkit-transition: top .2s ease-in-out,  font-size .2s ease-in-out;
            transition: top .2s ease-in-out,  font-size .2s ease-in-out;
            background: transparent;
        }
        .get{
        background: #E56E10;
        padding: 16px 32px;
        border-radius: 24px;
        color: #fefefe;
        border: none;
        margin: auto;
        &:focus{
            outline: none;
        }
        }
    }
    input:focus ~ .label, textarea:focus ~ .label, input:not(:placeholder-shown) ~ .label, textarea:not(:placeholder-shown) ~ .label {
        top: -0.8rem;
        font-size: 16px;
        color: #2B2D42;
        background: #F1F6F9;
        font-weight: 500;
        z-index: 1;
    }
}

@media (max-width: 480px) {
  #contact{
    background: url('../assets/Union.png');
    margin-top: -8%;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    padding: 80px 0;
    align-items: center;
    height: auto;
    font-family: 'Raleway', sans-serif;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 18px;
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    form{
        display: flex;
        flex-direction: column;
        width: 80%;
        position: relative;
        .form-group{
            position: relative;
        }
        input, textarea{
            position: relative;
            width: 100%;
            padding: 16px 32px;
            border-radius: 4px;
            border: 1px solid #2B2D4280;
            font-size: 18px;
            margin-bottom: 36px;
            background: transparent;
            z-index: 1;
            &:hover{
                border: 1px solid #FFC727;
            }
            &:focus{
                outline: 1px solid #FFC727;
            }
        }
        .label {
            position: absolute;
            left: 1rem;
            top: 0.8em;
            padding: 0 0.5rem;
            color: #13232A80;
            cursor: text;
            -webkit-transition: top .2s ease-in-out,  font-size .2s ease-in-out;
            transition: top .2s ease-in-out,  font-size .2s ease-in-out;
            background: transparent;
        }
        .get{
        background: #E56E10;
        padding: 16px 32px;
        border-radius: 24px;
        color: #fefefe;
        border: none;
        margin: auto;
        &:focus{
            outline: none;
        }
        }
    }
    input:focus ~ .label, textarea:focus ~ .label, input:not(:placeholder-shown) ~ .label, textarea:not(:placeholder-shown) ~ .label {
        top: -0.8rem;
        font-size: 16px;
        color: #2B2D42;
        background: #F1F6F9;
        font-weight: 500;
        z-index: 1;
    }
}
}

@media (min-width: 481px) and (max-width: 768px) {
  #contact{
    background: url('../assets/Union.png');
    margin-top: -8%;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    padding: 80px 0;
    align-items: center;
    height: auto;
    font-family: 'Raleway', sans-serif;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 18px;
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    form{
        display: flex;
        flex-direction: column;
        width: 80%;
        position: relative;
        .form-group{
            position: relative;
        }
        input, textarea{
            position: relative;
            width: 100%;
            padding: 16px 32px;
            border-radius: 4px;
            border: 1px solid #2B2D4280;
            font-size: 18px;
            margin-bottom: 36px;
            background: transparent;
            z-index: 1;
            &:hover{
                border: 1px solid #FFC727;
            }
            &:focus{
                outline: 1px solid #FFC727;
            }
        }
        .label {
            position: absolute;
            left: 1rem;
            top: 0.8em;
            padding: 0 0.5rem;
            color: #13232A80;
            cursor: text;
            -webkit-transition: top .2s ease-in-out,  font-size .2s ease-in-out;
            transition: top .2s ease-in-out,  font-size .2s ease-in-out;
            background: transparent;
        }
        .get{
        background: #E56E10;
        padding: 16px 32px;
        border-radius: 24px;
        color: #fefefe;
        border: none;
        margin: auto;
        &:focus{
            outline: none;
        }
        }
    }
    input:focus ~ .label, textarea:focus ~ .label, input:not(:placeholder-shown) ~ .label, textarea:not(:placeholder-shown) ~ .label {
        top: -0.8rem;
        font-size: 16px;
        color: #2B2D42;
        background: #F1F6F9;
        font-weight: 500;
        z-index: 1;
    }
}
}

@media (min-width: 769px) and (max-width: 1024px) {

}
</style>